var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscoverLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 24,
    rx: 2,
    fill: "#FBFAF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 24C24 24 32.8773 22.3605 38.6591 19.9184C44.4168 17.6964 48 15 48 15V24H24Z",
    fill: "#F16822"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5508 9.13745H40.5418C41.1772 9.13745 42.4418 9.46138 42.4418 10.8176C42.4418 12.1752 41.1345 12.4561 41.1345 12.4561L42.9989 14.8415H41.5166L39.8687 12.5649H39.7424V14.8415H38.5508V9.13745ZM39.7421 10.0884V11.7532H40.398C40.903 11.7532 41.2218 11.3278 41.2218 10.956V10.8846C41.2218 10.5135 40.903 10.0884 40.398 10.0884H39.7421Z",
    fill: "#2A2D2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0312 9.13745H29.3446L31.0259 12.8742L32.6105 9.13745H33.9242L31.3559 14.9863H30.5996L28.0312 9.13745Z",
    fill: "#2A2D2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4805 14.8415H11.7006V9.13745H10.4805V14.8415Z",
    fill: "#2A2D2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 9.13721H6.99741C8.19654 9.13721 9.9557 10.1548 9.9557 11.9633V11.9843V12.0057C9.9557 13.8146 8.19654 14.8315 6.99741 14.8315H5V9.13721ZM6.15015 13.8824C6.15015 13.8824 8.71397 14.1521 8.71397 12.033V11.9997C8.71397 9.88021 6.15015 10.1503 6.15015 10.1503V13.8824Z",
    fill: "#2A2D2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6657 11.3855V12.3915H35.5908V13.8352H37.7616V14.8413H34.3789V9.13721H37.7616V10.1433H35.5908V11.3855H37.6657Z",
    fill: "#2A2D2E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2452 12.0175C28.2452 13.6508 26.8265 14.9745 25.0778 14.9745C23.3284 14.9745 21.9102 13.6508 21.9102 12.0175C21.9102 10.3839 23.3284 9.05981 25.0778 9.05981C26.8265 9.05981 28.2452 10.3839 28.2452 12.0175",
    fill: "#F16822"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4407 10.4524C15.4407 10.4524 15.0387 10.0204 14.4989 10.0204C13.9602 10.0204 13.6489 10.3555 13.6489 10.5997C13.6489 10.8432 13.6388 10.981 14.4086 11.2808C15.1792 11.5816 16.3116 11.7975 16.3116 13.068C16.3116 14.3375 15.2462 14.9818 14.2884 14.9818C12.7772 14.9818 12.0977 13.8999 12.0977 13.8999L12.8581 13.1894C12.8581 13.1894 13.3402 13.9467 14.1812 13.9467C15.0219 13.9467 15.0687 13.3489 15.0687 13.1523C15.0687 12.8613 14.8877 12.5734 14.3685 12.3957C13.8493 12.2169 12.4296 12.0378 12.4296 10.7592C12.4296 9.61114 13.3485 9.04199 14.3787 9.04199C15.2994 9.04199 16.1004 9.71503 16.1004 9.71503L15.4407 10.4524Z",
    fill: "#2A2D2E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3832 10.6896C21.0056 10.3251 20.4857 10.0603 19.9005 10.0603C18.7535 10.0603 17.8237 10.9292 17.8237 11.9997C17.8237 13.0711 18.7535 13.939 19.9005 13.939C20.48 13.939 21.0075 13.677 21.3836 13.3191L21.3832 14.6617C20.9389 14.879 20.4358 15 19.9005 15C18.126 15 16.6875 13.6571 16.6875 11.9997C16.6875 10.3429 18.126 9 19.9005 9C20.4373 9 20.9386 9.12278 21.3832 9.34072V10.6896Z",
    fill: "#2A2D2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverLight);
export default __webpack_public_path__ + "static/media/discover-light.162595aca024a66b385e2b7281841410.svg";
export { ForwardRef as ReactComponent };